import React from 'react';
import styles from './ChangeEnvModal.module.scss'

interface IChangeEnvModalProps {
  handleClose(): void;
  handleConfirm(): void;
}

export const ChangeEnvModal = ({handleClose, handleConfirm} : IChangeEnvModalProps) => {
  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.text}>
          <p>
            Changing the Environment will reset the scene
          </p>
          <p>
            Do you want to continue?
          </p>
        </div>
      </div>
      <div className={styles.buttons}>
        <button type="button" onClick={handleClose}>Cancel</button>
        <button type="button" onClick={handleConfirm} className={styles.confirm}>Continue</button>
      </div>
    </>
  )
}
